import { setHeaderHeightVariable } from './modules/set-header-height-variable.js';
import { setViewportWidthVariable } from './modules/set-viewport-width-variable.js';
import { delayedScroll } from './modules/delayed-scroll.js';
import { disableTelOnPC } from './modules/disable-tel-on-pc.js';
import { overlay } from './modules/overlay.js';
import { tabs } from './modules/tabs.js';
import { accordion } from './modules/accordion.js';
import { contactFormConfirm } from './modules/contact-form-confirm.js';
import { stickyHeader } from './modules/sticky-header.js';
import { megaMenu } from './modules/mega-menu.js';
import { fvLoading } from './modules/fv-loading.js';
import { scrollReveal } from './modules/scroll-reveal.js';
import { columnToc } from './modules/column-toc.js';
import { columnShare } from './modules/column-share.js';

/**
 * メインJavaScript - 各モジュールの初期化
 */
document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeightVariable();
  setViewportWidthVariable();
  delayedScroll();
  disableTelOnPC();
  overlay();
  tabs();
  accordion();
  contactFormConfirm();
  stickyHeader();
  megaMenu();
  fvLoading();
  columnToc();
  columnShare();
  // ローディングがある場合は退場完了（500ms）後に scroll-reveal を開始
  const hasLoading = !!document.getElementById('js-loading');
  scrollReveal({ startDelay: hasLoading ? 600 : 0 });
});

/**
 * CF7 バリデーションエラー時に最初のエラー箇所へスクロール
 */
document.addEventListener('wpcf7invalid', () => {
  setTimeout(() => {
    const firstError = document.querySelector('.wpcf7-not-valid');
    if (!firstError) return;
    const headerHeight =
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--js-height__header',
        ),
      ) || 0;
    const scrollTop =
      window.scrollY +
      firstError.getBoundingClientRect().top -
      headerHeight -
      24;
    window.scrollTo({ top: scrollTop, behavior: 'smooth' });
  }, 0);
});

/**
 * CF7 送信完了後にサンクスページへリダイレクト
 */
document.addEventListener('wpcf7mailsent', () => {
  const config = window.contactFormConfig;
  if (config?.thanksPageUrl) {
    window.location.href = config.thanksPageUrl;
  }
});
